import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FetchResult, MutationFunctionOptions, useMutation, useQuery } from '@apollo/client';
import {
  Button,
  Grid,
  Chip,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextField,
  Container,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  createStyles,
  Theme,
  Collapse,
  FormControl,
  Hidden
} from '@material-ui/core';
//import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  ProfileForm,
  ProfileQueryData,
  ProfileQueryVariables,
  PROFILE_MUTATION,
  PROFILE_MUTATION_WO_PART_PROF_POSITION,
  PROFILE_QUERY,
} from './profile-model';
import { Classification, Locale, Participant } from '../core/api/model';
import { Controller, useForm } from 'react-hook-form';
import SpinnerModal from '../core/spinner-modal';
import CustomIcon from "../core/custom-icon";
import {makeStyles} from "@material-ui/core/styles";
import { Link as RouterLink, matchPath, useHistory, useLocation } from 'react-router-dom';
import corporationRoutes from '../corporation/routes'

// @TODO REFACTORING move to participant and split into separate components

const MEETING_PROFILE_PATHNAME_CONFIRM_START = '/virtual-meet/lobby/';
const MEETING_PROFILE_PATHNAME_CANCEL_START = '/virtual-meet/cancel/';

const selectOptionsPartIndustry = [
  {"key": "Wind turbine manufacturer", "description": {"de_DE": "Windenergie-Anlagenhersteller", "en_GB": "Wind turbine manufacturer"}}, 
  {"key": "Components/ supplier", "description": {"de_DE": "Komponenten/ Zulieferer", "en_GB": "Components/ supplier"}}, 
  {"key": "Installation/ logistics", "description": {"de_DE": "Installation/ Logistik", "en_GB": "Installation/ logistics"}}, 
  {"key": "Planning/ project development", "description": {"de_DE": "Planung/ Projektentwicklung", "en_GB": "Planning/ project development"}}, 
  {"key": "Operations/ maintenance", "description": {"de_DE": "Betrieb/ Wartung", "en_GB": "Operations/ maintenance"}}, 
  {"key": "Smart energy/ energy supply", "description": {"de_DE": "Smart Energy/ Energieversorgung", "en_GB": "Smart energy/ energy supply"}}, 
  {"key": "Finance/ insurance", "description": {"de_DE": "Finanzierung/ Versicherung", "en_GB": "Finance/ insurance"}}, 
  {"key": "Consultancy/ service provider", "description": {"de_DE": "Dienstleistung/ Beratung", "en_GB": "Consultancy/ service provider"}}, 
  {"key": "Other", "description": {"de_DE": "Sonstige", "en_GB": "Other"}}, 
  {"key": "Certification/ classification body", "description": {"de_DE": "Zertifizierung/ Klassifizierung", "en_GB": "Certification/ classification body"}}, 
  {"key": "Commercial service", "description": {"de_DE": "Kaufmännische Dienstleistung", "en_GB": "Commercial service"}}, 
  {"key": "Port/ marine technology (ROVs/ AUVs etc)", "description": {"de_DE": "Hafen/ Meerestechnologie (ROVs/ AUVS etc.)", "en_GB": "Port/ marine technology (ROVs/ AUVs etc)"}}, 
  {"key": "Public authorities", "description": {"de_DE": "Öffentlicher Sektor", "en_GB": "Public authorities"}}, 
  {"key": "R&D/ university/ institute", "description": {"de_DE": "F&E/ Universität/ Forschungseinrichtung", "en_GB": "R&D/ university/ institute"}}, 
  {"key": "Technical service (drones/ UAVs, geomatic engineering, windmonitoring etc.)", "description": {"de_DE": "Technische Service (Drohnen/ UAVs, Geomatik, Windmonitoring etc.)", "en_GB": "Technical service (drones/ UAVs, geomatic engineering, windmonitoring etc.)"}}, 
  {"key": "Association/ economic promotion", "description": {"de_DE": "Verband/ Wirtschaftsförderung", "en_GB": "Association/ economic promotion"}}, 
  {"key": "Power to X/ power conversion/ storage", "description": {"de_DE": "Power to X/ Energieumwandlung/ Speicher", "en_GB": "Power to X/ power conversion/ storage"}}, 
  {"key": "Data management/ IoT/ AI/ blockchain", "description": {"de_DE": "Data management/ IoT / KI / Blockchain", "en_GB": "Data management/ IoT/ AI/ blockchain"}}, 
];

const selectOptionsPartResponsibility = [
  {"key": "Management", "description": {"de_DE": "Geschäfts-, Unternehmens-, Betriebsleitung", "en_GB": "Management"}}, 
  {"key": "R&D/ strategic dev", "description": {"de_DE": "F&E/ Strategie", "en_GB": "R&D/ strategic dev"}}, 
  {"key": "Technical / quality", "description": {"de_DE": "Fertigung, Produktion, Qualitätskontrolle", "en_GB": "Technical / quality"}}, 
  {"key": "Purchasing", "description": {"de_DE": "Einkauf", "en_GB": "Purchasing"}}, 
  {"key": "Financial", "description": {"de_DE": "Finanzen", "en_GB": "Financial"}}, 
  {"key": "Information technologies/ communication", "description": {"de_DE": "IT & Kommunikation", "en_GB": "Information technologies/ communication"}}, 
  {"key": "HR", "description": {"de_DE": "Personal/ Verwaltung", "en_GB": "HR"}}, 
  {"key": "Sales", "description": {"de_DE": "Vertrieb", "en_GB": "Sales"}}, 
  {"key": "Marketing, PR", "description": {"de_DE": "Marketing/ PR", "en_GB": "Marketing, PR"}}, 
  {"key": "Operations/ logistics", "description": {"de_DE": "Betrieb/ Logistik", "en_GB": "Operations/ logistics"}}, 
  {"key": "Maintenance/ repairs", "description": {"de_DE": "Wartung/ Instandhaltung", "en_GB": "Maintenance/ repairs"}}, 
  {"key": "Other", "description": {"de_DE": "Anderer Bereich", "en_GB": "Other"}}, 
];

export enum ProfileMode {
  Closed,
  Init,
  Edit,
  Meeting,
}

interface Props {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      ProfileBackground: {
        //backgroundImage: 'url("/pattern-HMCA-Mobile.svg")',
        backgroundPosition: 'center -1px',
        backgroundRepeat: 'no-repeat',

        [theme.breakpoints.up('md')]: {
          backgroundImage: 'url("/pattern-HMCA-Desktop.svg")',
          backgroundPosition: 'center -1px',
          backgroundRepeat: 'no-repeat'
        }
      },
      profileEditButton: {
        marginLeft: theme.spacing(-1),

        [theme.breakpoints.up('md')]: {
          marginBottom: theme.spacing(-1),
          marginTop: 'auto'
        }
      },
      avatarWrapper: {
        marginRight: theme.spacing(1),
        position: 'relative',

        [theme.breakpoints.up('md')]: {
          marginRight: theme.spacing(2)
        },

        '&::before': {
          background: theme.palette.common.white,
          content: '" "',
          display: 'block',
          position: 'absolute',
          top: -8,
          right: 16,
          height: 40,
          width: 32,

          [theme.breakpoints.up('md')]: {
            top: -16,
            right: 0,
            height: 127,
            width: 60
          }
        }
      },
      avatarListItem: {
        alignItems: 'stretch'
      },
      avatar: {
        marginRight: theme.spacing(3),
        backgroundColor: theme.palette.secondary.main,
        height: 61,
        width: 61,

        [theme.breakpoints.up('md')]: {
          height: 151,
          width: 151,
        }
      },
      avatarIcon: {
        height: 40,
        width: 40,

        [theme.breakpoints.up('md')]: {
          height: 80,
          width: 80,
        }
      },
      description: {
        fontWeight: 'bold',
      },
      logoutButton: {
        paddingRight: 0,
      }
    }),
);

const Profile: React.FunctionComponent<Props> = (props) => {
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const meetingRouteMatch = matchPath<{uuid: string}>(location.pathname, {
    ...corporationRoutes.profile,
    path: corporationRoutes.profile.url,
    strict: true,
    exact: true
  });
  const [uuid, setUuid] = useState(meetingRouteMatch?.params?.uuid);
  const [profileMode, setProfileMode] = React.useState<ProfileMode>(ProfileMode.Closed);

  useEffect(() => {
    if (meetingRouteMatch) {
      setUuid(meetingRouteMatch.params.uuid)
    }
  }, [meetingRouteMatch, setUuid, setProfileMode]);

  useEffect(() => {
    if (meetingRouteMatch) {
      setProfileMode(ProfileMode.Meeting)
    }

    if (!meetingRouteMatch && profileMode === ProfileMode.Meeting) {
      setProfileMode(ProfileMode.Closed)
    }
  }, [meetingRouteMatch, profileMode, setProfileMode, location])
  
  useEffect(() => {
    if (location.hash === '#init-profile') {
      setProfileMode(ProfileMode.Init)
    }
  }, [location, setProfileMode])

  const [selectedClassifications, setSelectedClassifications] = React.useState<number[]>([]);
  //const [selectedCorporation, setSelectedCorporation] = React.useState<Partial<Corporation>>({});

  const { control, handleSubmit, setValue, /*errors*/ } = useForm<ProfileForm>();
  
  const { data, loading, refetch } = 
    useQuery<ProfileQueryData, ProfileQueryVariables>(
      PROFILE_QUERY, {
        variables: { expoCode: process.env.REACT_APP_EXPO_CODE || '' },
        onCompleted: (_data) => {
          const classificationId = _data?.participant[0].classification.map(classification => classification.classificationId) || [];
          setSelectedClassifications(classificationId);
          if (!(_data.participant.length > 0)) {
            props.showErrorModal(intl.formatMessage({id: 'ProfileQueryNoDataTitle'}), intl.formatMessage({id: 'ProfileQueryNoDataDescription'}));
          } else {
            setValue('partGender', _data.participant[0].partGender || 'A');
            setValue('partName', _data.participant[0].partName || '');
            setValue('partSurname', _data.participant[0].partSurname || '');
            setValue('partEmail1', _data.participant[0].partEmail1 || '');
            setValue('partTimezoneOffset', _data.participant[0].partTimezoneOffset || 0);
            //setSelectedCorporation(_data.participant[0].corporation[0]);
            setValue('partCompany2', _data.participant[0].partCompany2 || '');
            setValue('partIndustry', _data.participant[0].partIndustry || '');
            setValue('partProfPosition', _data.participant[0].partProfPosition);
            setValue('partResponsibility', _data.participant[0].partResponsibility || '');
            setValue('partFunction', _data.participant[0].partFunction || '');
            setValue('classificationId', classificationId);
          }
        },
        onError: (error) => {
          props.showErrorModal(intl.formatMessage({id: 'ProfileQueryErrorTitle'}), intl.formatMessage({id: 'ProfileQueryErrorDescription'}));
        }
      }
    );
  
  // @TODO REFACTORING combine the following two queries
  const [submitMutation, {loading: pendingMutation}] = useMutation(PROFILE_MUTATION, {
    onCompleted: data => {
      switch(profileMode) { 
        case ProfileMode.Meeting: { 
          history.push(`${MEETING_PROFILE_PATHNAME_CONFIRM_START}${uuid}`);
          break;
        }
        default: {
          setProfileMode(ProfileMode.Closed);
          refetch(); // @TODO REFACTORING find better option but reflect that product panel might be changed as well
          break;
        }
      }
    },
    onError: (error) => {
      props.showErrorModal(intl.formatMessage({id: 'ProfileMutationErrorTitle'}), intl.formatMessage({id: 'ProfileMutationErrorDescription'}));
    }
  });
  const [submitMutationWoPartProfPosition, {loading: pendingMutation2}] = useMutation(PROFILE_MUTATION_WO_PART_PROF_POSITION, {
    onCompleted: data => {
      switch(profileMode) { 
        case ProfileMode.Meeting: { 
          history.push(`${MEETING_PROFILE_PATHNAME_CONFIRM_START}${uuid}`);
          break;
        }
        default: {
          setProfileMode(ProfileMode.Closed);
          refetch(); // @TODO REFACTORING find better option but reflect that product panel might be changed as well
          break;
        }
      }
    },
    onError: (error) => {
      props.showErrorModal(intl.formatMessage({id: 'ProfileMutationErrorTitle'}), intl.formatMessage({id: 'ProfileMutationErrorDescription'}));
    }
  });

  const submitForm = useCallback((data: ProfileForm, participant: Participant | undefined, mutation: (options?: MutationFunctionOptions<any, Record<string, any>> | undefined) => Promise<FetchResult<any, Record<string, any>, Record<string, any>>>) => {
    mutation({ variables: { 
      partId: participant?.partId || 0,
      expoCode: process.env.REACT_APP_EXPO_CODE,
      partLanguage: participant?.partLanguage || props.locale,
      ...data, // partEmail1 is required and included here
    } })
  }, [props.locale]);

  const getConfirmButtonText = useCallback(() => {
    switch(profileMode) { 
      case ProfileMode.Closed: {
        return intl.formatMessage({id: 'ProfileEdit'})
      }
      case ProfileMode.Meeting: { 
        return intl.formatMessage({id: 'ProfileButtonSaveMeetingRedirect'})
      } 
      default: { 
        return intl.formatMessage({id: 'ProfileButtonSaveClose'})
      } 
    }
  }, [profileMode, intl]);

  const getConfirmButtonIcon = useCallback(() => {
    switch(profileMode) { 
      case ProfileMode.Closed: {
        return <CustomIcon iconname='settings' />
      }
      case ProfileMode.Meeting: { 
        return <CustomIcon iconname='videoCall' />
      } 
      default: { 
        return <CustomIcon iconname='settingsDone' />
      } 
    }
  }, [profileMode]);

  const confirm = useCallback((_data: ProfileForm) => {
    switch(profileMode) { 
      case ProfileMode.Closed: {
        setProfileMode(ProfileMode.Edit);
        break;
      }
      default: { 
        submitForm(_data, data?.participant[0] , _data.partProfPosition ? submitMutation : submitMutationWoPartProfPosition);
        break;
      } 
    }
  }, [profileMode, submitForm, data, submitMutation, submitMutationWoPartProfPosition]);

  const getCancelButtonText = useCallback(() => {
    switch(profileMode) { 
      case ProfileMode.Meeting: { 
        return intl.formatMessage({id: 'ProfileButtonDiscardChangesMeetingRedirect'})
      } 
      default: { 
        return intl.formatMessage({id: 'ProfileButtonDiscardChanges'})
      } 
    }
  }, [profileMode, intl]);

  const cancel = useCallback(() => {
    switch(profileMode) { 
      case ProfileMode.Meeting: { 
        history.push(`${MEETING_PROFILE_PATHNAME_CANCEL_START}${uuid}`);
        break;
      } 
      default: { 
        setProfileMode(ProfileMode.Closed);
        break;
      } 
    }
  }, [profileMode, setProfileMode, history, uuid]);

  const locale = props.locale;

  const classes = useStyles();

  return (
    <Box bgcolor='primary.main'
         color='common.white'
         pt={{xs: 2, md: 4}}
         pb={{xs: 1, md: 5}}
         className={classes.ProfileBackground}
    >
      <Container maxWidth="lg">
        <SpinnerModal
          active={loading || pendingMutation || pendingMutation2}
        ></SpinnerModal>

        <form onSubmit={handleSubmit(confirm)}>
          <Fragment>
            <Box display='flex'
                alignItems={{md: 'flex-start'}}
                justifyContent={'space-between'}
                flexDirection={{xs: 'column-reverse', md: 'row'}}
            >
              <Box>
                <List component='div' disablePadding={true}>
                  <ListItem disableGutters={true}
                            component='div'
                            className={classes.avatarListItem}
                  >

                    {/*<ListItemAvatar className={classes.avatarWrapper}>*/}
                    {/*  <Avatar className={classes.avatar}*/}
                    {/*          alt={data?.participant[0].partName + ' ' + data?.participant[0].partSurname}*/}
                    {/*          src={data?.participant[0].partPic?.url}>*/}
                    {/*    <CustomIcon iconname='emptyProfile' viewBox="0 0 40 40" className={classes.avatarIcon} />*/}
                    {/*  </Avatar>*/}
                    {/*</ListItemAvatar>*/}
                    <Box display='flex' flexDirection='column'>
                      <Box mb={{xs: 0, md: 2.5}}>
                        <Typography variant='subtitle1'>
                          {data?.participant[0].partName} {data?.participant[0].partSurname}{' '}
                        </Typography>
                      </Box>
                      <Hidden smDown>
                        <Typography>
                          {data?.participant[0].partFunction}{' '}
                        </Typography>
                        <Typography gutterBottom>
                          {data?.participant[0].partCompany2}{' '}
                        </Typography>
                      </Hidden>

                      {profileMode === ProfileMode.Meeting ?
                        // @TODO workaround to get form data  
                        <Button className={classes.profileEditButton}
                                variant='text'
                                color='inherit'
                                type='submit'
                                disabled={pendingMutation}
                                startIcon={getConfirmButtonIcon()}
                        >
                          {getConfirmButtonText()}
                        </Button>
                      :
                        <Button className={classes.profileEditButton}
                                variant='text'
                                color='inherit'
                                onClick={handleSubmit(confirm)}
                                startIcon={getConfirmButtonIcon()}>
                          {getConfirmButtonText()}
                        </Button>
                      }

                    </Box>
                  </ListItem>

                </List>

              </Box>

              <Box display='flex'
                  justifyContent={{xs: 'space-between', md: 'flex-end'}}
                  bgcolor='primary.main'
                  mb={{xs: 2, md: 0}}
                  mt={{xs: 0, md: 2}}
              >
                <Box display='inline-flex' mr={4}>
                  <Button variant='outlined'
                          color='inherit'
                          component={RouterLink}
                          to="/"
                          endIcon={<CustomIcon iconname='dashboard' />}
                  >
                    <FormattedMessage id='Dashboard' />
                  </Button>
                </Box>
                <Button component='a'
                        variant='text'
                        color='inherit'
                        className={classes.logoutButton}
                        href={process.env.REACT_APP_LOGOUT_URL}
                        endIcon={<CustomIcon iconname='logout' />}
                >
                  <FormattedMessage id='Logout' />
                </Button>
              </Box>
            </Box>

          </Fragment>

          <Collapse in={profileMode !== ProfileMode.Closed}>
            <Box pt={{xs: 6, md: 10}} pb={{xs: 5, md: 0}}>
              <Grid container>
                <Grid item md={6}>
                  <Box pb={5}>
                    {(() => {
                      switch(profileMode) {
                        case ProfileMode.Init: {
                          return <Fragment>
                            <Typography component='h2' variant='h1' gutterBottom>
                              <FormattedMessage id='ProfileTitleInit' />
                            </Typography>
                            <Typography className={classes.description}>
                              <FormattedMessage id='ProfileDescriptionInit' />
                            </Typography>
                          </Fragment>
                        }
                        case ProfileMode.Edit: {
                          return <Fragment>
                            <Typography component='h2' variant='h1' gutterBottom>
                              <FormattedMessage id='ProfileTitleEdit' />
                            </Typography>
                            <Typography className={classes.description}>
                              <FormattedMessage id='ProfileDescriptionEdit' />
                            </Typography>
                          </Fragment>
                        }
                      }
                    })()}
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={6}>
                <Grid item md={6}>
                  <Typography component='h2' variant='h2' gutterBottom>
                    <FormattedMessage id='ProfilePersonalData' />
                  </Typography>

                  <FormControl margin='normal' fullWidth>
                    <InputLabel
                        id='partGenderLabel'
                        className='form--white'
                    >
                      <FormattedMessage id='ParticipantSalutation' />
                    </InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId='partGenderLabel'
                          className='form--white'
                          inputProps={{
                            classes: {
                              icon: 'form--white',
                            }
                          }}
                        >
                          <MenuItem value='A'>
                            <FormattedMessage id='ProfileSalutationUnknown' />
                          </MenuItem>
                          <MenuItem value='W'>
                            <FormattedMessage id='ProfileSalutationFemale' />
                          </MenuItem>
                          <MenuItem value='M'>
                            <FormattedMessage id='ProfileSalutationMale' />
                          </MenuItem>
                        </Select>
                      }
                      name='partGender'
                      control={control}
                      defaultValue={data?.participant[0].partGender || 'A'}
                    />
                  </FormControl>

                  <Controller
                    as={<TextField
                        className='form--white'
                        margin='normal'
                        fullWidth
                        InputLabelProps={{
                          className: 'form--white'
                        }}
                        InputProps={{
                          className: 'form--white'
                        }}
                    />}
                    name='partName'
                    control={control}
                    label={intl.formatMessage({id: 'ParticipantName'})}
                    defaultValue={data?.participant[0].partName || ''}
                  />

                  <Controller
                    as={<TextField
                        className='form--white'
                        margin='normal'
                        fullWidth
                        InputLabelProps={{
                          className: 'form--white'
                        }}
                        InputProps={{
                          className: 'form--white'
                        }}
                    />}
                    name='partSurname'
                    control={control}
                    label={intl.formatMessage({id: 'ParticipantSurname'})}
                    defaultValue={data?.participant[0].partSurname || ''}
                  />

                  <Controller
                    as={<TextField
                        className='form--white'
                        margin='normal'
                        fullWidth
                        InputLabelProps={{
                          className: 'form--white'
                        }}
                        InputProps={{
                          readOnly: true,
                          className: 'form--white'
                        }}
                    />}
                    name='partEmail1'
                    control={control}
                    label={intl.formatMessage({id: 'ParticipantEmail1'})}
                    defaultValue={data?.participant[0].partEmail1 || ''}
                  />

                  {/* @TODO REFACTORING duplicate exists */}
                  <FormControl margin='normal' fullWidth>
                    <InputLabel id='partTimezoneOffsetLabel'
                                className='form--white'
                    >
                      <FormattedMessage id='ParticipantTimezoneOffset' />
                    </InputLabel>
                    <Controller
                        as={
                          <Select
                              labelId='partTimezoneOffsetLabel'
                              className='form--white'
                              inputProps={{
                                classes: {
                                  icon: 'form--white',
                                }
                              }}
                          >
                            <MenuItem key={-12} value={-12}>UTC -12</MenuItem>
                            <MenuItem key={-11} value={-11}>UTC -11</MenuItem>
                            <MenuItem key={-10} value={-10}>UTC -10</MenuItem>
                            <MenuItem key={-9} value={-9}>UTC -9</MenuItem>
                            <MenuItem key={-8} value={-8}>UTC -8</MenuItem>
                            <MenuItem key={-7} value={-7}>UTC -7</MenuItem>
                            <MenuItem key={-6} value={-6}>UTC -6</MenuItem>
                            <MenuItem key={-5} value={-5}>UTC -5</MenuItem>
                            <MenuItem key={-4} value={-4}>UTC -4</MenuItem>
                            <MenuItem key={-3} value={-3}>UTC -3</MenuItem>
                            <MenuItem key={-2} value={-2}>UTC -2</MenuItem>
                            <MenuItem key={-1} value={-1}>UTC -1</MenuItem>
                            <MenuItem key={0} value={0}>UTC</MenuItem>
                            <MenuItem key={1} value={1}>UTC +1</MenuItem>
                            <MenuItem key={2} value={2}>UTC +2</MenuItem>
                            <MenuItem key={3} value={3}>UTC +3</MenuItem>
                            <MenuItem key={4} value={4}>UTC +4</MenuItem>
                            <MenuItem key={5} value={5}>UTC +5</MenuItem>
                            <MenuItem key={6} value={6}>UTC +6</MenuItem>
                            <MenuItem key={7} value={7}>UTC +7</MenuItem>
                            <MenuItem key={8} value={8}>UTC +8</MenuItem>
                            <MenuItem key={9} value={9}>UTC +9</MenuItem>
                            <MenuItem key={10} value={10}>UTC +10</MenuItem>
                            <MenuItem key={11} value={11}>UTC +11</MenuItem>
                            <MenuItem key={12} value={12}>UTC +12</MenuItem>
                            <MenuItem key={13} value={13}>UTC +13</MenuItem>
                            <MenuItem key={14} value={14}>UTC +14</MenuItem>
                          </Select>
                        }
                        name='partTimezoneOffset'
                        control={control}
                        defaultValue={data?.participant[0].partTimezoneOffset || 0}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <Typography component='h2' variant='h2' gutterBottom>
                    <FormattedMessage id='ProfileProfileDetails'/>
                  </Typography>
                  
                  {/* @ TODO REFACTORING fix warnings */}
                  {/* 
                  <Autocomplete
                      disableClearable
                      classes={{
                        popupIndicator: 'form--white'
                      }}
                      options={data?.corporation || []}
                      getOptionLabel={(corporation: Partial<Corporation>) => corporation?.corpName ? corporation?.corpName[locale] : ''}
                      value={selectedCorporation}
                      onChange={(event, value) => { setSelectedCorporation(value) }}
                      renderInput={(props) => <TextField {...props} margin='normal' InputLabelProps={{className: 'form--white'}} InputProps={{...props.InputProps, className: 'form--white'}} className='form--white'  label={intl.formatMessage({ id: 'ParticipantCorporation' })} variant="standard" />}
                  /> 
                  */}
                  <Controller
                    as={<TextField
                        className='form--white'
                        margin='normal'
                        fullWidth
                        InputLabelProps={{
                          className: 'form--white'
                        }}
                        InputProps={{
                          className: 'form--white'
                        }}
                    />}
                    name='partCompany2'
                    control={control}
                    label={intl.formatMessage({id: 'ParticipantCorporation'})}
                    defaultValue={data?.participant[0].partCompany2 || ''}
                  />

                  <FormControl margin='normal' fullWidth>
                    <InputLabel
                        id='partIndustryLabel'
                        className='form--white'
                    >
                      <FormattedMessage id='ParticipantIndustry' />
                    </InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId='partIndustryLabel'
                          className='form--white'
                          inputProps={{
                            classes: {
                              icon: 'form--white',
                            }
                          }}
                        >
                          <MenuItem key='undefined' value={' '} disabled={true} hidden={true} />
                          {selectOptionsPartIndustry.map((position) => {
                            return <MenuItem key={position.key} value={position.key}>
                              {position.description[locale]}
                            </MenuItem>
                          }
                          )}
                        </Select>
                      }
                      name='partIndustry'
                      control={control}
                      defaultValue={data?.participant[0].partIndustry || ''}
                    />
                  </FormControl>

                  <FormControl margin='normal' fullWidth>
                    <InputLabel
                        id='partProfPositionLabel'
                        className='form--white'
                    >
                      <FormattedMessage id='ParticipantProfessionalPosition' />
                    </InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId='partProfPositionLabel'
                          className='form--white'
                          inputProps={{
                            classes: {
                              icon: 'form--white',
                            }
                          }}
                        >
                          <MenuItem key='undefined' disabled={true} hidden={true}/>
                          {data?.__type && data?.__type.TeilnehmerBeruflicheStellung &&
                          data?.__type.TeilnehmerBeruflicheStellung.map((position) => {
                            try {
                              const description = JSON.parse(position.description || '{"de_DE": "", "en_GB": "" }')[locale];
                              return <MenuItem key={position.key} value={position.key}>
                                {description}
                              </MenuItem>
                            }
                            catch {
                            }
                          }
                          )}
                        </Select>
                      }
                      name='partProfPosition'
                      control={control}
                      defaultValue={data?.participant[0].partProfPosition || ''}
                    />
                  </FormControl>

                  <FormControl margin='normal' fullWidth>
                    <InputLabel
                        id='partResponsibilityLabel'
                        className='form--white'
                    >
                      <FormattedMessage id='ParticipantResponsibility' />
                    </InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId='partResponsibilityLabel'
                          className='form--white'
                          inputProps={{
                            classes: {
                              icon: 'form--white',
                            }
                          }}
                        >
                          <MenuItem key='' value={' '} disabled={true} hidden={true}/>
                          {selectOptionsPartResponsibility.map((position) => {
                            return <MenuItem key={position.key} value={position.key}>
                              {position.description[locale]}
                            </MenuItem>
                          }
                          )}
                        </Select>
                      }
                      name='partResponsibility'
                      control={control}
                      defaultValue={data?.participant[0].partResponsibility || ''}
                    />
                  </FormControl>


                  <Controller
                    as={<TextField
                        className='form--white'
                        margin='normal'
                        fullWidth
                        InputLabelProps={{
                          className: 'form--white'
                        }}
                        InputProps={{
                          className: 'form--white'
                        }}
                    />}
                    name='partFunction'
                    control={control}
                    label={intl.formatMessage({id: 'ParticipantFunction'})}
                    defaultValue={data?.participant[0].partFunction || ''}
                  />

                  <Box mt={{xs: 4, md: 4}} mb={{xs: 1, md: 1}}>
                    <Typography component='h2' variant='h2'>
                      <FormattedMessage id='ProfileInterests' />
                    </Typography>
                  </Box>

                  <FormControl margin='normal' fullWidth>
                    <InputLabel
                        id='classificationLabel'
                        className='form--white'
                    >
                      <FormattedMessage id='ParticipantClassificationSelect' />
                    </InputLabel>
                    <Controller
                      render={props => (
                        <Select
                          labelId='classificationLabel'
                          className='form--white'
                          inputProps={{
                            classes: {
                              icon: 'form--white',
                            }
                          }}
                          multiple
                          fullWidth
                          variant='standard'
                          value={selectedClassifications}
                          onChange={(event: any) => {
                            setSelectedClassifications(event.target.value);
                            setValue('classificationId', event.target.value);
                          }}
                          renderValue={selected => (
                            <Box display='flex' flexWrap='wrap' mb={-1}>
                              {(selected as string[]).map(classificationId => (
                                <Chip className='chip--white chip--select' variant='outlined' key={classificationId} label={data?.classification.find((classification: Classification) => classification.classificationId === +classificationId)?.classificationTitle[locale]} />
                              ))}
                            </Box>
                          )}
                        >
                          {data?.classification &&  data.classification.map((classification: Classification) => (
                            <MenuItem key={classification.classificationId} value={classification.classificationId}>
                              {classification.classificationTitle[locale]}
                            </MenuItem>
                          )
                          )}
                        </Select>
                      )}
                      name='classificationId'
                      control={control}
                      multiple
                      defaultValue={[]}
                    />
                  </FormControl>

                  <Box display='flex'
                       flexDirection={{xs: 'column-reverse', md: 'row'}}
                       justifyContent={{md: 'flex-end'}}
                       mt={{xs: 4, md: 7}}
                  >

                    <Box display={{xs: 'flex', md: 'inline-flex'}}
                         mr={{md: 6}}
                         mt={{xs: 2, md: 0}}
                    >
                      <Button className='button--white'
                              variant='text'
                              color='secondary'
                              fullWidth
                              onClick={cancel} disabled={pendingMutation}
                      >
                        {getCancelButtonText()}
                      </Button>
                    </Box>

                    <Button className='button--white'
                            color='primary'
                            type='submit'
                            disabled={pendingMutation}
                    >
                      {getConfirmButtonText()}
                    </Button>

                  </Box>
                </Grid>
              </Grid>

              </Box>
          </Collapse>
        </form>

      </Container>
    </Box>
  );
};

export default Profile;
